import { apiHeliosClient } from 'src/data/api/apiHeliosClient';
import {
  CreateTaskCommand,
  CreateTaskCommandInput,
  CreateTaskFromQuestionCommand,
  CreateTaskFromQuestionCommandInput,
  CreateTaskFromQuestionCommandOutput,
  ListTasksCommand,
  ListTasksCommandInput,
  ListTasksCommandOutput,
  AuditorUpdateTaskCommand,
  AuditorUpdateTaskCommandInput,
  AuditorUpdateTaskCommandOutput,
} from '@amzn/gbsa-helios-typescript-client';
import { apiClient } from 'src/data/api/apiClient';
import { ServiceType, API_ENDPOINTS, createApiUrl } from 'src/contstant/apiEndpoints';

export const taskService = {
  list: (data: ListTasksCommandInput) => {
    return apiHeliosClient.send(new ListTasksCommand(data));
  },
  /**
   * Fetches tasks via raw HTTP GET, bypassing the Smithy deserializer.
   * TODO: Switch back to TypeScript client (taskService.list) once the backend
   * returns date fields in RFC-3339 format so the Smithy deserializer can parse them.
   */
  listRaw: (data: ListTasksCommandInput) => {
    const { businessUnitId, ...params } = data;
    return apiClient.get<ListTasksCommandOutput>(
      ServiceType.HELIOS,
      createApiUrl(API_ENDPOINTS.HELIOS_SERVICE.TASKS.LIST(businessUnitId)),
      params,
    );
  },
  create: (data: CreateTaskCommandInput) => {
    return apiHeliosClient.send(new CreateTaskCommand(data));
  },
  createFromQuestion: (data: CreateTaskFromQuestionCommandInput) => {
    return apiHeliosClient.send(new CreateTaskFromQuestionCommand(data));
  },
  /**
   * Creates a task from a question via raw HTTP POST, bypassing the Smithy deserializer.
   * TODO: Switch back to TypeScript client (taskService.createFromQuestion) once the backend
   * returns date fields in RFC-3339 format so the Smithy deserializer can parse them.
   */
  createFromQuestionRaw: (data: CreateTaskFromQuestionCommandInput) => {
    const { businessUnitId, ...body } = data;
    return apiClient.post<CreateTaskFromQuestionCommandOutput, typeof body>(
      ServiceType.HELIOS,
      createApiUrl(
        API_ENDPOINTS.HELIOS_SERVICE.TASKS.CREATE_FROM_QUESTION(businessUnitId),
      ),
      body,
    );
  },
  auditorUpdate: (data: AuditorUpdateTaskCommandInput) => {
    return apiHeliosClient.send(new AuditorUpdateTaskCommand(data));
  },
  /**
   * Updates a task via raw HTTP PUT, bypassing the Smithy deserializer.
   * TODO: Switch back to TypeScript client (taskService.auditorUpdate) once the backend
   * returns date fields in RFC-3339 format so the Smithy deserializer can parse them.
   */
  auditorUpdateRaw: (data: AuditorUpdateTaskCommandInput) => {
    const { businessUnitId, taskId, ...body } = data;
    return apiClient.put<AuditorUpdateTaskCommandOutput, typeof body>(
      ServiceType.HELIOS,
      createApiUrl(
        API_ENDPOINTS.HELIOS_SERVICE.TASKS.AUDITOR_UPDATE(businessUnitId, taskId!),
      ),
      body,
    );
  },
};
